import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import thestore from '~/data/store/store'
import FileManager from '~/pages/cp/includes/fileManager/fileManager'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import MergeTags from '~/pages/cp/includes/mergeTags/mergeTags'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import axios from '~/data/http/axios'
import ComponentTagManager from './tagManager'
import siteVars from '~/Classes/siteVars'

@connect((store) => {
    return { site: store.siteMaster, account: store.accountMaster }
})
export default class LinkPicker extends Component {
    constructor(props) {
        super(props)
        this.state = {
            linkUrl: '',
            formId: null,
            domains: [],
            linkUrlErr: '',
            linkType: -1,
            emailMessage: '',
            emailSubject: '',
            formData: [],
            selectedTags: [],
            formAllowData: false,
            anchorsDetected: [],
            anchorWarning: ''
        }

        this.node = null

        this.updateVal = this.updateVal.bind(this)
        this.save = this.save.bind(this)
        this.openFilePicker = this.openFilePicker.bind(this)
        this.insertMergeTag = this.insertMergeTag.bind(this)
        this.getForms = this.getForms.bind(this)
        this.findAnchors = this.findAnchors.bind(this)
        this.parseCurrVal = this.parseCurrVal.bind(this)
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    handleClickOutside(ev) {
        if (!this.node) return
        const inPicker =
            this.node.contains(ev.target) ||
            ev.target.closest('.topnav-dropdown') ||
            ev.target.closest('.uiDrawerInner')
        if (inPicker) return
        ev.stopPropagation()
        ev.preventDefault()
        this.props.close()
    }

    parseCurrVal(currVal) {
        if (!currVal) {
            return null
        }
        var theVal = currVal
        var anchorWarning = ''
        var emailMessage = ''
        var emailSubject = ''
        var formAllowData = false
        var formId = null
        var ourState = thestore.getState()
        var ourAccMasterId = 0
        if (ourState.accountMaster && ourState.accountMaster.id) {
            ourAccMasterId = ourState.accountMaster.id
        }
        var linkType = 0

        if (theVal.toLowerCase().indexOf('mailto:') === 0) {
            theVal = theVal.replace(/mailto\:/g, '')

            if (theVal.indexOf('?') > 0) {
                var tmpDat1 = theVal.split('?')
                theVal = tmpDat1[0]
                var tmpDat = tmpDat1[1]
                var emailData = [tmpDat]
                if (tmpDat.indexOf('&') > 0) {
                    emailData = tmpDat.split('&')
                }
                emailData.forEach((tLine) => {
                    if (tLine.indexOf('=') > 0) {
                        var tDat = tLine.split('=')
                        if (tDat[0] == 'subject') {
                            emailSubject = decodeURIComponent(tDat[1])
                        }
                        if (tDat[0] == 'body') {
                            emailMessage = decodeURIComponent(tDat[1])
                        }
                    }
                })
            }
            linkType = 1
        }
        if (theVal.toLowerCase().indexOf(`/usercontent/${ourAccMasterId}`) > -1) {
            linkType = 2
        }
        if (theVal.toLowerCase().indexOf('/form?am=') > -1) {
            linkType = 3
            if (theVal.toLowerCase().indexOf('&fid=') > -1) {
                formId = theVal.split('&fid=')[1].split('&')[0]
            }
            if (theVal.indexOf('&key={{__SENDKEY}}') > -1) {
                formAllowData = true
            }
        }
        if (theVal.indexOf('tel:') === 0) {
            linkType = 4
        }
        if (theVal.indexOf('#') === 0) {
            linkType = 5
            let foundAnchor = this.state.anchorsDetected.find((an) => an.value == theVal)
            if (!foundAnchor) {
                anchorWarning = `Previously selected anchor "${theVal}" no longer exists in your template. Please select another Anchor.`
            }
            if (!this.state.anchorsDetected.length) {
                linkType = 0
                anchorWarning = ''
                theVal = ''
            }
        }
        return { linkUrl: theVal, linkType, formId, emailMessage, emailSubject, formAllowData, anchorWarning }
    }

    componentDidMount() {
        if (this.props.captureClickOutside) {
            document.addEventListener('mousedown', this.handleClickOutside)
        }
        this.findAnchors()
        axios.get('/accountMaster/tracking').then((response) => {
            this.setState({
                domains: response.data.Domains.filter((d) => d.authenticated && d.sslDone)
            })
        })
        const parsed = this.parseCurrVal(this.props.currVal)
        if (parsed) {
            this.setState(parsed, () => {
                if (parsed.linkType == 3) {
                    this.getForms(true)
                }
            })
        }
    }
    componentWillUnmount() {
        if (this.props.captureClickOutside) {
            document.removeEventListener('mousedown', this.handleClickOutside)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currVal !== this.props.currVal) {
            const parsed = this.parseCurrVal(this.props.currVal)
            if (parsed) {
                this.setState(parsed, () => {
                    if (parsed.linkType == 3) {
                        this.getForms(true)
                    }
                })
            } else {
                this.setState({
                    linkUrl: '',
                    emailMessage: '',
                    emailSubject: '',
                    formAllowData: false,
                    anchorWarning: ''
                })
            }
        }
        if (prevProps.elementsData !== this.props.elementsData) {
            this.findAnchors()
        }
    }

    save() {
        var errored = false
        var errMessage = ''
        var thisLink = this.state.linkUrl
        if (this.state.linkType == '0' && thisLink.length) {
            if (thisLink.indexOf('http://') < 0 && thisLink.indexOf('https://') < 0 && thisLink.indexOf('@') > -1) {
                thisLink = 'mailto:' + thisLink
            } else if (
                thisLink.indexOf('http://') == -1 &&
                thisLink.indexOf('https://') == -1 &&
                thisLink.indexOf('}}') == -1
            ) {
                thisLink = 'http://' + thisLink
            }
            if (thisLink.indexOf('.') == -1 && thisLink.indexOf('}}') == -1) {
                errored = true
                errMessage = 'Please enter a valid URL'
            }

            if (thisLink.length > 1000) {
                errored = true
                errMessage = 'The URL is too long. Must be less than 1000 characters.'
            }
        }
        if (this.state.linkType == '1' && thisLink.length) {
            if (thisLink.indexOf('mailto:') == -1 && thisLink.indexOf('}}') == -1) {
                thisLink = 'mailto:' + thisLink
            }
            if (thisLink.indexOf('@') == -1 && thisLink.indexOf('}}') == -1) {
                errored = true
                errMessage = 'Please enter a valid email address'
            }
            if (!errored) {
                if (this.state.emailSubject && this.state.emailSubject.length) {
                    var delim = '?'
                    if (thisLink.indexOf('?') > 0) delim = '&'
                    var emailSubj = encodeURIComponent(this.state.emailSubject)
                    thisLink += `${delim}subject=${emailSubj}`
                }
                if (this.state.emailMessage && this.state.emailMessage.length) {
                    var delim = '?'
                    if (thisLink.indexOf('?') > 0) delim = '&'
                    var emailMsg = encodeURIComponent(this.state.emailMessage)
                    thisLink += `${delim}body=${emailMsg}`
                }
            }
        }
        if (this.state.linkType == '2' && thisLink.length) {
            if (thisLink.length < 3) {
                errored = true
                errMessage = 'Please select a file'
            }
        }

        if (this.state.linkType == '4' && thisLink.length) {
            if (thisLink.indexOf('tel:') === -1) {
                thisLink = 'tel:' + thisLink
            }
        }

        if (errored) {
            this.setState({ linkUrlErr: errMessage })
            return
        }

        this.setState({ linkUrlErr: '' })
        thisLink = thisLink.trim()

        let openType = '_blank'
        if (this.state.linkType == 5) {
            openType = '_self'
        }

        this.props.save(thisLink, openType, '')
    }

    getForms(updateState) {
        var self = this
        return axios.get('/group/0/form').then((resp) => {
            const formData = resp.data.Forms.filter((f) => f.formType == 0)
            if (this.state.formId && !formData.find((f) => f.id == this.state.formId)) {
                self.setState({ linkUrlErr: 'Form not found' })
                return
            }
            if (updateState) {
                self.setState({ formData })
                return
            }
            return { type: 'form', data: formData }
        })
    }
    updateVal(ev) {
        var self = this
        var state = this.state
        var promises = []
        var targetValue = ev.target.value
        state.anchorWarning = ''
        if (ev.target.name == 'linkType') {
            state.linkUrl = ''
            state.linkUrlErr = ''
            state.formAllowData = false
            if (targetValue == 3 || targetValue == '3') {
                promises.push(this.getForms())
            }
            state[ev.target.name] = Number(targetValue)
        } else {
            state[ev.target.name] = targetValue
        }

        if (ev.target.name == 'formAllowData' || (ev.target.name == 'linkUrl' && state.linkType == 3)) {
            let newFormAllowDataState = ev.target.value
            if (ev.target.name == 'formAllowData') {
                this.setState({ formAllowData: newFormAllowDataState })
                if (newFormAllowDataState == true) {
                    state.linkUrl += '&key={{__SENDKEY}}'
                } else {
                    state.linkUrl = state.linkUrl.replace('&key={{__SENDKEY}}', '')
                }
            }
            if (ev.target.name == 'linkUrl') {
                let newLinkUrl = targetValue
                if (state.formAllowData) {
                    state.linkUrl = newLinkUrl + '&key={{__SENDKEY}}'
                }
            }
        }

        if (promises.length) {
            Promise.all(promises).then((_resp) => {
                if (_resp && _resp[0] && _resp[0].type == 'form') {
                    state.formData = _resp[0].data
                }
                self.setState(state, () => {
                    if (this.props.inline) {
                        self.save()
                    }
                })
            })
        } else {
            this.setState(state, () => {
                if (this.props.inline) {
                    self.save()
                }
            })
        }
    }

    openFilePicker() {
        var self = this
        this.props.toggleHidePickers(true)
        var theDrawer = (
            <FileManager
                onFileClick={(theFile) => {
                    this.updateVal({ target: { name: 'linkUrl', value: theFile.url } })
                    thestore.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, true, null))
                    setTimeout(() => {
                        self.props.toggleHidePickers(false)
                    }, 500)
                }}
            />
        )
        thestore.dispatch(
            siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, true, '100vw', undefined, () => {
                setTimeout(() => {
                    self.props.toggleHidePickers(false)
                }, 500)
            })
        )
    }

    insertMergeTag(field) {
        var self = this
        var state = this.state
        this.props.toggleHidePickers(true)
        var theDrawer = (
            <MergeTags
                mergeTags={DragDropFunctions.mergeTags}
                onTagClick={(theTag) => {
                    if (state[field] && state[field].length) {
                        state[field] = state[field] + theTag
                    } else {
                        state[field] = theTag
                    }
                    self.setState(state)
                    if (this.props.standalone) {
                        this.setState({ drawerContent: undefined })
                    } else {
                        thestore.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, true, null))
                    }
                    setTimeout(() => {
                        self.props.toggleHidePickers(false)
                    }, 500)
                }}
            />
        )
        if (this.props.standalone) {
            this.setState({ drawerContent: theDrawer })
        } else {
            thestore.dispatch(
                siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, true, 500, undefined, (event) => {
                    setTimeout(() => {
                        self.props.toggleHidePickers(false)
                    }, 500)
                })
            )
        }
    }

    findAnchors() {
        let anchorsDetected = DragDropFunctions.findAllAnchors(this.props.elementsData)
        this.setState({ anchorsDetected })
    }

    render() {
        var fileNameD = ''
        var fileNameDat = this.state.linkUrl.split('/')
        if (fileNameDat.length) {
            fileNameD = fileNameDat[fileNameDat.length - 1]
        }

        let linkTypes = [
            { label: 'None', value: -1 },
            { label: 'Website', value: 0 },
            { label: 'Email Address', value: 1 },
            { label: 'Telephone Number', value: 4 },
            { label: 'File', value: 2 },
            { label: 'Form', value: 3 }
        ]

        if (this.state.anchorsDetected.length) {
            linkTypes.push({
                label: 'Anchor',
                value: 5
            })
        }

        const outerClassName = this.props.inline ? 'dd_inputTool mar-b0' : 'mpzLinkPicker'

        var domain = this.props.site.trackingDomain
        let ownDomin = false
        if (this.state.domains && this.state.domains.length) {
            domain = this.state.domains[0].domainName
            ownDomin = true
        }

        const isFree =
            this.props.account &&
            this.props.account.accountMaster &&
            this.props.account.accountMaster.accountType == 'free' &&
            ownDomin

        const hideEmailOnlyLinkTools = !!this.props.isLandingPage

        return (
            <div
                className={outerClassName}
                onClick={(ev) => {
                    ev.preventDefault()
                    ev.stopPropagation()
                }}
                ref={(el) => {
                    this.node = el
                }}
            >
                <Select
                    outerClassName={this.props.inline ? 'mar-b8' : 'mar-b20'}
                    label='Link To'
                    name='linkType'
                    value={this.state.linkType}
                    onChange={this.updateVal}
                    data={linkTypes}
                    usePortal={this.props.usePortal}
                    dropdownStyle={this.props.dropDownStyle}
                />
                {this.state.linkType == 0 && (
                    <div className={this.props.inline ? 'mar-b10' : 'mar-b20'}>
                        <TextInput
                            outerClassName={this.props.inline ? 'mar-b0' : ''}
                            label={this.props.inline ? '' : 'Website Address'}
                            value={this.state.linkUrl}
                            name='linkUrl'
                            onChange={this.updateVal}
                            error={this.state.linkUrlErr}
                            placeholder='https://'
                        />
                        {!hideEmailOnlyLinkTools && (
                            <div className='text-xsml mar-t10 mar-b10 text-right'>
                                <a
                                    onClick={() => {
                                        this.insertMergeTag('linkUrl')
                                    }}
                                >
                                    Insert Merge Tag
                                </a>
                            </div>
                        )}

                        {!hideEmailOnlyLinkTools && (
                            <ComponentTagManager
                                value={this.state.linkUrl}
                                usePortal={false}
                                dropdownStyle={this.props.dropDownStyle}
                                title='Link Tags'
                                innerClassName={''}
                            />
                        )}
                    </div>
                )}
                {this.state.linkType == 4 && (
                    <div className={this.props.inline ? 'mar-b10' : 'mar-b20'}>
                        <TextInput
                            outerClassName={this.props.inline ? 'mar-b0' : ''}
                            label={this.props.inline ? '' : 'Telephone Number'}
                            value={this.state.linkUrl}
                            name='linkUrl'
                            onChange={this.updateVal}
                            error={this.state.linkUrlErr}
                            placeholder='tel:'
                        />
                    </div>
                )}
                {this.state.linkType == 1 && (
                    <div>
                        <TextInput
                            outerClassName={this.props.inline ? 'mar-b10' : 'mar-b20'}
                            label={this.props.inline ? '' : 'Email Address'}
                            value={this.state.linkUrl}
                            name='linkUrl'
                            placeholder='Email Address'
                            onChange={this.updateVal}
                            error={this.state.linkUrlErr}
                        />

                        <div className={this.props.inline ? 'mar-b10' : 'mar-b20'}>
                            <TextInput
                                outerClassName={this.props.inline ? 'mar-b0' : ''}
                                label={this.props.inline ? '' : 'Email Subject (Optional)'}
                                value={this.state.emailSubject}
                                name='emailSubject'
                                placeholder='Email Subject'
                                onChange={this.updateVal}
                            />
                            {!hideEmailOnlyLinkTools && (
                                <div className='text-right mar-t10 text-xsml'>
                                    <a
                                        onClick={() => {
                                            this.insertMergeTag('emailSubject')
                                        }}
                                    >
                                        Insert Merge Tag
                                    </a>
                                </div>
                            )}
                        </div>

                        <div className={this.props.inline ? 'mar-b10' : 'mar-b20'}>
                            <TextInput
                                outerClassName={this.props.inline ? 'mar-b0' : ''}
                                label={this.props.inline ? '' : 'Email Message (Optional)'}
                                value={this.state.emailMessage}
                                name='emailMessage'
                                placeholder='Email Message'
                                onChange={this.updateVal}
                            />
                            {!hideEmailOnlyLinkTools && (
                                <div className='text-right mar-t10 text-xsml'>
                                    <a
                                        onClick={() => {
                                            this.insertMergeTag('emailMessage')
                                        }}
                                    >
                                        Insert Merge Tag
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {this.state.linkType == 2 && (
                    <div>
                        {!this.props.inline && <div className='txtInput_label'>File URL:</div>}
                        {this.state.linkUrl && this.state.linkUrl.length > 0 && (
                            <div className='txtInput mar-b15'>{fileNameD}</div>
                        )}
                        {this.state.linkUrlErr && this.state.linkUrlErr.length > 0 && (
                            <WarningHolder className='mar-b15'>{this.state.linkUrlErr}</WarningHolder>
                        )}
                        <Button
                            text='Pick a File'
                            className='button-primary mar-b20'
                            onClick={this.openFilePicker}
                        />
                    </div>
                )}
                {this.state.linkType == 3 && (
                    <div>
                        <div>
                            {!this.props.inline && <div className='txtInput_label'>Form to Link To:</div>}
                            {this.state.formData.length > 0 && (
                                <Select
                                    outerClassName='mar-b20'
                                    placeholder='Please select a Form'
                                    usePortal={this.props.usePortal}
                                    dropdownStyle={this.props.dropDownStyle}
                                    data={this.state.formData.map((frm) => {
                                        const formUrl =
                                            (isFree ? 'http://' : 'https://') +
                                            domain +
                                            '/form?am=' +
                                            this.props.account.id +
                                            '&fid=' +
                                            frm.id +
                                            '&host=true'
                                        return {
                                            label:
                                                frm.formName +
                                                (frm.Group
                                                    ? frm.Group.groupName
                                                        ? ' (For group ' + frm.Group.groupName + ')'
                                                        : ''
                                                    : ''),
                                            value: formUrl
                                        }
                                    })}
                                    value={this.state.linkUrl.replace('&key={{__SENDKEY}}', '')}
                                    name='linkUrl'
                                    onChange={this.updateVal}
                                    error={this.state.linkUrlErr}
                                />
                            )}

                            {!this.state.formData.length && (
                                <WarningHolder className='mar-b20'>
                                    <div>You have not added any forms yet</div>
                                    <a
                                        onClick={() => {
                                            window.open('/cp/forms', '_blank')
                                        }}
                                    >
                                        Add a Form
                                    </a>
                                </WarningHolder>
                            )}
                        </div>
                        {this.state.linkUrl && this.state.linkUrl.length && (
                            <div>
                                <Select
                                    label='Pre-populate fields with contacts existing details, if sent from a campaign or automation'
                                    outerClassName='mar-b20'
                                    data={[
                                        { label: 'Yes', value: true },
                                        { label: 'No', value: false }
                                    ]}
                                    value={this.state.formAllowData}
                                    name='formAllowData'
                                    usePortal={this.props.usePortal}
                                    dropdownStyle={this.props.dropDownStyle}
                                    onChange={this.updateVal}
                                />
                            </div>
                        )}
                    </div>
                )}
                {this.state.linkType == 5 && (
                    <div>
                        <div className='txtInput_label'>Anchor:</div>
                        <Select
                            name='linkUrl'
                            placeholder='Pick an Anchor'
                            data={this.state.anchorsDetected}
                            value={this.state.linkUrl}
                            usePortal={this.props.usePortal}
                            dropdownStyle={this.props.dropDownStyle}
                            onChange={this.updateVal}
                            outerClassName='mar-b20'
                        />
                        {this.state.anchorWarning && (
                            <WarningHolder className='mar-b20'>{this.state.anchorWarning}</WarningHolder>
                        )}
                    </div>
                )}
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                    {!this.props.inline && (
                        <Button className='button-primary' text='Save Link' onClick={this.save} />
                    )}
                    {!this.props.inline && !this.props.hideCancelButton && (
                        <Button className='' text='Cancel' onClick={this.props.close} />
                    )}
                    {this.props.showRemoveButton && (
                        <Button
                            className='button-red'
                            text='Remove'
                            onClick={() => {
                                this.updateVal({ target: { name: 'linkUrl', value: '' } })
                                this.save()
                            }}
                        />
                    )}
                </div>
                {!!this.state.drawerContent && (
                    <Drawer
                        close={() => {
                            this.setState({ drawerContent: undefined })
                        }}
                        standalone={true}
                        isOpen={true}
                        width={500}
                        showClose={true}
                    >
                        {this.state.drawerContent}
                    </Drawer>
                )}
            </div>
        )
    }
}
